import {ensureHasId} from './hs-util';

function timeToKey(t) {
	return 't' + Math.floor(t * 10);
}

abstract class BasePlayer {
	protected _seeked:boolean;
	isFullscreenControllable:boolean;
	$el:JQuery;
	$overlay:JQuery;
	$vid:JQuery;
	readyFired:boolean;
	protected _videoChecked:boolean;
	timeListeners:Array<any>;
	playListeners:Array<any>;
	pauseListeners:Array<any>;
	readyListeners:Array<any>;

	abstract play(): void;
	abstract pause(): void;
	abstract seek(time:number): void;
	abstract duration(): number;

	// returns the current time index of the video
	abstract time(): number;

	constructor($el:JQuery, seekTime:number) {
		var j = 0;
		let now = Date.now();

		ensureHasId($el[0]);

		this.readyFired = false;
		this.timeListeners = [];
		this.playListeners = [];
		this.pauseListeners = [];
		this.readyListeners = [];
		this._seeked = false;
		this.$el = $el;
		this._videoChecked = false;
		this.isFullscreenControllable = false;

		$el.css({overflow: 'hidden'});

		this.onReady(() => {
			this.seek(seekTime);
			this._seeked = true;
		});
	}

	showOverlay($overlay:JQuery) {
		if (this.$overlay) {
			this.removeOverlay();
		}
		this.$overlay = $overlay;
		$('object, video', this.$el).css('top', -6000);

		// create shade
		var $shade = $('<div class="shade"></div>');
		this.$el.append($shade);
		$shade.css('opacity', 0.8);

		// create an overlay over shade to contain content
		this.$el.append($overlay);
		$overlay.addClass('overlay');
	}

	removeOverlay() {
		$('.shade', this.$el).remove();
		this.$overlay.remove();
		this.$overlay = null;
		$('object, video', this.$el).css('top', 0);
	}

	onTime(f):void {
		this.timeListeners.push(f);
	}

	offTime(f) {
		let listeners2 = [];
		this.timeListeners.forEach((l) => {
			if (l !== f) {
				listeners2.push(l);
			}
		});
		this.timeListeners = listeners2;
	}

	enterFullscreen():void {
		if (!this.isFullscreenControllable) {
			return;
		}
		this.$vid[0].webkitEnterFullscreen();
	}

	exitFullscreen() {
		if (!this.isFullscreenControllable) {
			return;
		}

		this.$vid[0].webkitExitFullscreen();
	}

	getIsFullscreen() {
		if (!this.isFullscreenControllable) {
			return false;
		}
		return this.$vid[0].webkitDisplayingFullscreen;
	}

	_fireTimeChanged(t:number) {
		this.timeListeners.forEach(function(l) {
			l(t);
		});
	}

	_firePlayEvent() {
		this.playListeners.forEach(function(l) {
			l();
		});
	}

	onPlay(f) {
		this.playListeners.push(f);
	}

	offPlay(f) {
		let listeners2 = [];
		this.playListeners.forEach((l) => {
			if (l !== f) {
				listeners2.push(l);
			}
		});
		this.playListeners = listeners2;
	}

	_firePauseEvent() {
		this.pauseListeners.forEach(function(l) {
			l();
		});
	}

	onPause(f) {
		this.pauseListeners.push(f);
	}

	offPause(f) {
		let listeners2 = [];
		this.pauseListeners.forEach((l) => {
			if (l !== f) {
				listeners2.push(l);
			}
		});
		this.pauseListeners = listeners2;
	}

	_fireReadyEvent() {
		this.readyListeners.forEach(function(l) {
			l();
		});
		this.readyFired = true;
	}

	onReady(f) {
		this.readyListeners.push(f);
		if (this.readyFired) {
			setTimeout(f, 1);
		}
	}

	offReady(f) {
		let listeners2 = [];
		this.readyListeners.forEach((l) => {
			if (l !== f) {
				listeners2.push(l);
			}
		});
		this.readyListeners = listeners2;
	}

}

class WistiaPlayer extends BasePlayer {
	private _wistiaEmbed:any;
	// Wistia player has a bug where play events are fired when the video
	// has just loaded but is not playing. So we do not emit the first
	// play event
	private firstPlayEvent: boolean;
	$vid: JQuery;
	ready: boolean;

	constructor($el, seekTime) {
		super($el, seekTime);

		let wkey = $el[0].className.match(/wistia_async_(\w+)/)[1];

		this.firstPlayEvent = true;
		window._wq = window._wq || [];
		window._wq.push({id: wkey,
			playerColor: $el.attr('data-wistia-player-color') || '5b905b',
			fullscreenButton: true,
			doNotTrack: false,
			autoPlay: false,
			onReady: (video) => {
				this._wistiaEmbed = video;

				this._wistiaEmbed.bind('timechange', (t) => {
					if (!this._videoChecked) {
						this.$vid = $('video', $el);
						if (this.$vid.size() > 0) {
							this.isFullscreenControllable = (!!this.$vid[0].webkitExitFullscreen) &&
								(!!this.$vid[0].webkitEnterFullscreen);
							this.$vid.css({position: 'absolute', top: 0, left: 0, zIndex: 0});
						}

						this._videoChecked = true;
					}

					this._fireTimeChanged(t);
				});

				this._wistiaEmbed.bind('play', () => {
					if (this.firstPlayEvent) {
						this.firstPlayEvent = false;
						let checkTime = this.time();
						setTimeout(() => {
							if (this.time() > checkTime) {
								this._firePlayEvent();
							}
						}, 2000);
					} else {
						this._firePlayEvent();
					}
				});

				this._wistiaEmbed.bind('pause', () => {
					this._firePauseEvent();
				});

				this._fireReadyEvent();

			}});

		if (!document.getElementById('wistia-embed-script')) {
			let scriptTag = document.createElement('script');
			scriptTag.id = 'wistia-embed-script';
			scriptTag.src = 'https://fast.wistia.com/static/concat/E-v1.js';
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
		}

	}

	play() {
		this._wistiaEmbed.play();
	}

	pause() {
		this._wistiaEmbed.pause();
	}

	seek(t) {
		if (typeof t !== 'undefined') {
			this._wistiaEmbed.time(Math.round(t));
		}
	}

	time() {
		return this._wistiaEmbed.time();
	}

	duration() {
		return this._wistiaEmbed.duration();
	}

}

class MockPlayer extends BasePlayer {
	_updateInterval: NodeJS.Timer;
	_milliseconds: number;
	_$timeReadout: JQuery;

	constructor($el, seekTime) {
		super($el, seekTime);

		this._milliseconds = 0;
		this._updateInterval = null;
		$el.addClass('mock');
		$el.append('<a class="mock-play" href="#">Play</a>').append(
			'<a class="mock-pause" href="#">Pause</a>'
		).append('<a class="mock-plus-1" href="#">+1:00</a>').append('<div class="time"></div>');

		this._$timeReadout = $el.find('div.time');

		$el.find('a.mock-play').on('click', (ev) => {
			ev.preventDefault();
			this.play();
		});

		$el.find('a.mock-pause').on('click', (ev) => {
			ev.preventDefault();
			this.pause();
		});

		$el.find('a.mock-plus-1').on('click', (ev) => {
			ev.preventDefault();
			this._milliseconds += 60000;
		});

		// FIXME: these elements should not be in the JS
		$el.find('a').css({position: 'absolute', bottom: '10px', left: '10px', color: 'white'});
		$el.find('div.time').css({
			'position': 'absolute', 'bottom': '50px', 'left': '10px',
			'color': 'white', 'font-size': '20px'});

		$el.find('a.mock-pause').css({'left': '90px'});
		$el.find('a.mock-plus-1').css({'left': '170px'});

		$.extend(this, MockPlayer);

		setTimeout(() => this._fireReadyEvent(), 400);
	}

	play() {
		if (this._updateInterval) {
			return;
		}

		this._firePlayEvent();

		var player = this;

		this._updateInterval = setInterval(function() {
			player._milliseconds += 100;
			var sec = player._milliseconds / 1000;
			player._updateReadout(sec);
			player._fireTimeChanged(sec);
		}, 100);
	}

	_updateReadout(s) {
		var m = Math.floor(s / 60);
		s = s % 60;
		var time;
		if (s < 10) {
			time = '' + m + ':0' + s;
		} else {
			time = '' + m + ':' + s;
		}

		if (time.length > 7) {
			time = time.substring(0, 7);
		}

		this._$timeReadout.text(time);
	}

	pause() {
		if (!this._updateInterval) {
			return;
		}
		clearInterval(this._updateInterval);
		this._updateInterval = null;
	}

	seek(t) {
		this._milliseconds = Math.round(t * 1000);
		this._updateReadout(t);
	}

	time() {
		return this._milliseconds / 1000.0
	}

	duration() {
		// Mock videos are always 2 minutes long
		return 120.0;
	}
}

class YoutubePlayer extends BasePlayer {
	_updateInterval: NodeJS.Timer;
	private _youtubeEmbed:any;
	$vid: JQuery;
	ready: boolean;
	lastTime: number;

	constructor($el, seekTime) {
		super($el, seekTime);

		// YouTube player has no timechange event, so onPlay we start an
		// interval timer to poll the time index every 0.5s, firing an event
		// if the time has changed.
		this.onPlay(() => {
			this.lastTime = this.time();
			if (this._updateInterval) {
				clearInterval(this._updateInterval);
				this._updateInterval = null;
			}

			this._updateInterval = setInterval(() => {
				let t = this.time();
				if (t !== this.lastTime) {
					this.lastTime = t;
					this._fireTimeChanged(t);
				}
			}, 500);
		});

		// stop interval to poll the youtube time, see onPlay handler above
		this.onPause(() => {
			if (this._updateInterval) {
				clearInterval(this._updateInterval);
				this._updateInterval = null;
			}
		});

		let ykey = $el[0].src.match(/youtube.com\/embed\/(\w+)/)[1];

		ensureHasId($el[0]);

		window._ytq = window._ytq || [];

		window._ytq.push(() => {
			let player = new window.YT.Player($el[0].id, {
				videoId: ykey,
				width: '' + $el.width(),
				height: '' + $el.height(),
				events: {
					onReady: () => {
						this._youtubeEmbed = player;
						player.seekTo({
							seconds: seekTime,
							allowSeekAhead: true
						});

						this._fireReadyEvent();
					},
					onStateChange: (ev) => {
						if (ev.data === window.YT.PlayerState.PLAYING) {
							this._firePlayEvent();
						} else if (ev.data === window.YT.PlayerState.PAUSED) {
							this._firePauseEvent();
						}
					}
				}
			});
		});

		if (!document.getElementById('youtube-embed-script')) {
			let scriptTag = document.createElement('script');
			scriptTag.id = 'youtube-embed-script';
			scriptTag.src = 'https://www.youtube.com/iframe_api';
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);

			window.onYouTubeIframeAPIReady = function() {
				while (window._ytq.length) {
					let f = window._ytq.pop();
					f();
				}
			};
		}

	}

	play() {
		this._youtubeEmbed.playVideo();
	}

	pause() {
		this._youtubeEmbed.pauseVideo();
	}

	seek(t) {
		if (typeof t !== 'undefined') {
			this._youtubeEmbed.seekTo({
				seconds: t,
				allowSeekAhead: true
			})
		}
	}

	time() {
		return this._youtubeEmbed.getCurrentTime();
	}

	duration() {
		return this._youtubeEmbed.getDuration();
	}
}

class LinkPlayer extends BasePlayer {
	constructor($el, seekTime) {
		super($el, seekTime);

		setTimeout(() => this._fireReadyEvent(), 10);

		$el.on('click', () => {
			this._firePlayEvent();
		});
	}

	play() {
		this.$el[0].click();
	}

	pause() {
	}

	seek(t) {
	}

	time() {
		return 0;
	}

	duration() {
		return 0;
	}
}

export function createPlayerInstance($el:JQuery, seekTime:number) {
	if ($el.length === 0) {
		return null;
	} else if ($el.hasClass('wistia_embed') && $el[0].className.match(/wistia_async_(\w+)/)) {
		return new WistiaPlayer($el, seekTime);
	} else if ($el.is('iframe') && ($el.attr('src') || '').indexOf('youtube') !== -1) {
		return new YoutubePlayer($el, seekTime);
	} else if ($el.is('a')) {
		return new LinkPlayer($el, seekTime);
	} else {
		return new MockPlayer($el, seekTime);
	}
}

// $.fn.videoSchedule = function(command, arg1, arg2, arg3) {
// 	var scalarReturn;
// 	var player;
// 	var internalSchedule;
//
// 	var $queryReturn = this.each(function() {
// 		var $el = $(this);
//
// 		if (command === 'player') {
// 			scalarReturn = $el.data('hshsPlayer') || null;
// 		} else if (command === 'add') {
// 			player = $el.data('hshsPlayer');
// 			internalSchedule = $el.data('hshsSchedule');
// 			if (!(player && internalSchedule)) {
// 				return;
// 			}
//
// 			var timeIndex = parseFloat(arg1);
// 			var callBack = arg2;
// 			var repeatOk = arg3;
// 			var entry = {
// 				time: timeIndex,
// 				callBack: callBack,
// 				activated: false,
// 				lastFired: 0,
// 				repeatOk: repeatOk,
// 			};
//
// 			for (var offset = 0.0; offset < 1.5; offset += 0.1) {
// 				var key = timeToKey(timeIndex + offset);
// 				if (!internalSchedule[key]) {
// 					internalSchedule[key] = [];
// 				}
//
// 				internalSchedule[key].push(entry);
// 			}
// 		} else { // default is to install player
//
// 			let Player = getPlayerType($el);
//
// 			if ($el.data('hshsPlayer')) {
// 				// already previously setup a player, no-op
// 				return;
// 			}
// 			var seekTo = parseFloat($el.attr('data-seek-to') || '0.0');
// 			internalSchedule = {};
// 			player = new Player($el, seekTo);
//
// 			$el.data('hshsPlayer', player).data('hshsSchedule', internalSchedule);
//
// 			var playScheduleAt = function(t) {
// 				var k = timeToKey(t);
// 				var entries = internalSchedule[k];
// 				if (!entries) {
// 					return;
// 				}
// 				var now = $.now();
// 				$.each(entries, function(id, entry) {
// 					if (entry.activated && !entry.repeatOk) {
// 						return;
// 					}
// 					// Note that this doesn't allow the entry to repeat
// 					// within 12 seconds This is specifically written
// 					// to exceed the backup timer of 10 seconds
// 					if ((now - entry.lastFired) < 12000) {
// 						return;
// 					}
// 					entry.lastFired = now;
// 					entry.activated = true;
//
// 					var secondsOff = t - entry.time;
// 					if (secondsOff > 0.5) {
// 						player.seek(entry.time);
// 					}
//
// 					entry.callBack(player, entry.time);
// 				});
// 			};
//
// 			player.onTime(playScheduleAt);
//
// 			// once the video starts playing, if we're waiting to seek,
// 			// seek then if a schedule object was passed, setup each entry now
// 			if (command) {
// 				var schedule = command;
// 				$.each(schedule, function(timeIndex, callBack) {
// 					$el.videoSchedule('add', timeIndex, callBack);
// 				});
// 			}
//
// 			// setup a backup timer to make sure events fire. Every 10 seconds it will try and fire any
// 			// scheduled events in the last 10 seconds
// 			var lastT = 0;
// 			setInterval(function() {
// 				var currentTime = player.time();
// 				if (Math.abs(currentTime - lastT) < 10) {
// 					return;
// 				}
// 				lastT = currentTime;
// 				for (var t = currentTime - 10.0; t <= currentTime; t += 0.5) {
// 					playScheduleAt(t);
// 				}
// 			}, 10000);
// 		} // finish installing
// 	});
//
// 	if (typeof scalarReturn !== 'undefined') {
// 		return scalarReturn;
// 	} else {
// 		return $queryReturn;
// 	}
// };
